import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditClient } from '../add-client-details/add-client-details.component';
import { MatDivider } from '@angular/material/list';

interface PropertyDetails {
	id: string;
	name: string;
	address: string;
	apartmentSuite?: string;
	townCity: string;
	stateProvince?: string;
	postalCode?: string;
	country?: string;
}

@Component({
	selector: 'app-add-client-confirmation',
	templateUrl: './add-client-confirmation.component.html',
	styleUrls: [
		'./add-client-confirmation.component.scss',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [MatDivider],
})
export class AddClientConfirmationComponent implements OnInit {
	@Input() editClient!: EditClient;
	@Input() selectedProperty?: any; // PropertyResult from property-setup component or preselected property
	@Input() isPropertyPreselected: boolean = false; // Whether property was preselected (coming from property's clients tab)
	@Output() returnToClients = new EventEmitter<void>();
	@Output() addAnotherClient = new EventEmitter<void>();

	propertyDetails?: PropertyDetails;

	constructor() {}

	ngOnInit(): void {
		if (this.selectedProperty) {
			const property = this.selectedProperty.property;
			this.propertyDetails = {
				id: property.id,
				name: property.name,
				address: property.address?.address1 || '',
				apartmentSuite: property.address?.address2,
				townCity: property.address?.locality || '',
				stateProvince: property.address?.stateProvinceRegion,
				postalCode: property.address?.postalCode,
				country: property.address?.countryCode,
			};
		}
	}

	formatAddress(): string {
		if (!this.propertyDetails) {
			return '';
		}

		const parts: string[] = [];

		if (this.propertyDetails.apartmentSuite) {
			parts.push(this.propertyDetails.apartmentSuite);
		}
		parts.push(this.propertyDetails.address);
		parts.push(this.propertyDetails.townCity);

		if (this.propertyDetails.stateProvince) {
			parts.push(this.propertyDetails.stateProvince);
		}
		if (this.propertyDetails.postalCode) {
			parts.push(this.propertyDetails.postalCode);
		}
		if (this.propertyDetails.country) {
			parts.push(this.propertyDetails.country);
		}

		return parts.join(', ');
	}

	getReturnButtonText(): string {
		if (this.isPropertyPreselected && this.propertyDetails) {
			return (
				$localize`:@@addClientConfirmation-returnToPropertyButton:Return to` +
				' ' +
				this.propertyDetails.name +
				' ' +
				$localize`:@@addClientConfirmation-clients:Clients`
			);
		}
		return $localize`:@@addClientConfirmation-returnButton:Return to All Clients`;
	}

	onReturnToClientsClick(): void {
		this.returnToClients.emit();
	}

	onAddAnotherClientClick(): void {
		this.addAnotherClient.emit();
	}
}
